/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import type { TFunction } from "i18next";
import { BackendError } from "./backend";

/** Translate API failures for the UI; retain BackendError messages for diagnostics. */
export function localizedRequestError(error: unknown, t: TFunction): string {
  if (error instanceof BackendError) {
    switch (error.status) {
      case 400:
        return t("instance.errors.invalid_request");
      case 401:
        return t("instance.errors.sign_in_required");
      case 403:
        return t("instance.errors.forbidden");
      case 404:
        return t("instance.errors.not_found");
      case 409:
        return t("instance.errors.conflict");
      case 429:
        return t("instance.errors.rate_limited");
      default:
        return t("instance.errors.server_error");
    }
  }
  if (error instanceof TypeError) return t("instance.errors.connection_error");
  return error instanceof Error && error.message
    ? error.message
    : t("instance.errors.request_failed");
}
